import React from "react";
import EntityTable from "../EntityTable";
import {
  anchorConnectionColumnId,
  renderRowUpdateAction,
} from "../../common/TableUtils";
import { ConnectionFormDataController } from "../../controllers/formController";
import { Person } from "../../types/person";
import { MRT_ColumnDef } from "material-react-table";
import useTeamMemberQuery from "../../hooks/query/connections/useTeamMemberQuery";
import { TeamMember, TeamMemberFilters } from "../../types/teamMember";
import { Team } from "../../types/team";
import {
  teamMemberConnectionColumns as teamMemberColumns,
  teamMemberFilterSpec,
} from "../../common/entities/TeamMemberColumns";
import TeamMemberDialog from "../modals/TeamMember/TeamMemberDialog";
import useServerFilters from "../../hooks/useServerFilters";

interface TeamMemberConnectionTableProps {
  columns?: MRT_ColumnDef<TeamMember, any>[];
  filters: TeamMemberFilters;
  controller: ConnectionFormDataController<TeamMember, Team, Person>;
}

const TeamMemberTable: React.FC<TeamMemberConnectionTableProps> = ({
  columns = teamMemberColumns,
  controller,
  filters,
}) => {
  const {
    serverFilters,
    entityTableFilterProps,
    pagination,
    setPagination,
  } = useServerFilters(filters, teamMemberFilterSpec);
  const { useFetchConnectedEdges } = useTeamMemberQuery(
    filters.system_language_type
  );
  const { anchorEntity, direction, openEditDialog } = controller;
  const { data, isLoading, errorMessage } = useFetchConnectedEdges(
    anchorEntity._id,
    direction,
    {
      bodyParams: serverFilters,
      externalPagination: pagination,
      externalSetPagination: setPagination,
    }
  );

  const renderRowActions = renderRowUpdateAction<TeamMember>((row) =>
    openEditDialog(row._key)
  );

  return (
    <>
      <EntityTable
        loading={isLoading}
        error={errorMessage}
        columns={columns}
        hiddenColumnIds={[anchorConnectionColumnId(direction)]}
        renderRowActions={renderRowActions}
        enableRowActions
        data={data?.data || []}
        pagination={pagination}
        manualPagination={true}
        onPaginationChange={setPagination}
        totalRowCount={data?.total || 0}
        manualFiltering
      {...entityTableFilterProps}
      />
      <TeamMemberDialog
        systemLanguageType={filters.system_language_type}
        controller={controller}
      />
    </>
  );
};

export default TeamMemberTable;
